import React, {Component} from 'react';
import { connect } from 'react-redux'
import { login } from '../../actions/authActions';
import RequestAuth from '../presentation/RequestAuth';
import Login from '../presentation/Login';
import { withRouter } from "react-router-dom";
import { Redirect } from 'react-router'

class Auth extends Component {
    render() {
        const { auth_key } = this.props.match.params;

        if(auth_key && !this.props.auth.auth_result.success)
            this.props.login(auth_key);

        return ( 
            <div>
                {this.props.auth.auth_result.success ? <Redirect to="/" /> : <div><Login /></div>}              
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    auth: state.auth,
    match: ownProps.match
})

const mapDispatchToProps = dispatch => ({
    login: payload => dispatch(login(payload)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Auth));


// WEBPACK FOOTER //
// ./src/components/layouts/Auth.js